import { render, staticRenderFns } from "./NeedApproveEmployees.vue?vue&type=template&id=5bf36867"
import script from "./NeedApproveEmployees.vue?vue&type=script&lang=js"
export * from "./NeedApproveEmployees.vue?vue&type=script&lang=js"
import style0 from "./NeedApproveEmployees.vue?vue&type=style&index=0&id=5bf36867&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports